module.exports = __webpack_public_path__ + "img/hotel-real-palacio.e0c9a51b.jpg";